<template>
  <div class="pt-8 px-5">
    <ManutenzioneGestioneSediFornitori
      :back_as_landing_page="true"
      :checkbox_strutture_standard="false"
      :cod_filtro_sede="cod_filtro_sede"
      :config_sede="config_sede"
      :config_struttura="config_struttura"
      :config_area="config_area"
      :config_zona="config_zona"
      :config_stanza="config_stanza"
      :config_macchinario="config_macchinario"
      :config_marca="config_marca"
      :config_matricola="config_matricola"
      :config_modello="config_modello"
      :config_zona_geografica="config_zona_geografica"
      :get_sedi_from_macchine="true"
      :rotta_back="'/home/naval'"
      :titolo_tabella_principale="'Lista Barche'"
    />
  </div>
</template>
<script>
import ManutenzioneGestioneSediFornitori from "@/components/MANUTENZIONE/ManutenzioneGestioneSediFornitori.vue";
export default {
  name: "DGGestioneLF",
  components: { ManutenzioneGestioneSediFornitori },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      cod_filtro_sede: 'NAVE',
      config_area: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_macchinario: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_marca: {
        label: {
          singolare: "Marca",
          plurale: "Marche",
        },
        visibility: true,
      },
      config_matricola: {
        label: {
          singolare: "Matricola HIN",
          plurale: "Matricole HIN",
        },
        visibility: true,
      },
      config_modello: {
        label: {
          singolare: "Modello e Num. Scafo",
          plurale: "Modelli",
        },
        visibility: true,
      },
      config_sede: {
        label: { singolare: "Nome Barca", plurale: "Nomi Barche" },
        visibility: true,
      },
      config_stanza: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_struttura: {
        label: { singolare: "Zona Barca", plurale: "Zone Barca" },
        visibility: true,
      },
      config_zona: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_zona_geografica: {
        label: { singolare: "Zona Geografica", plurale: "Zone Geografiche" },
        visibility: true,
      },
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>